<template>
  <Modal v-if="grimoire.modal === 'signals'" class="signals" @close="grimoire.toggleModal(null)">
    <h3>{{ t("modal.signals.title") }}</h3>

    <label class="signal-target">
      {{ t("modal.signals.target") }}
      <select v-model="signalsStore.targetPlayerId">
        <option v-for="player in players" :key="player.id || player.name" :value="player.id || player.name">
          {{ player.name }}
        </option>
      </select>
    </label>

    <section class="signal-section">
      <SignalComposer />
      <button type="button" class="signal-send" :disabled="!signalsStore.draft.length"
        @click="signalsStore.send('info')">
        {{ t("modal.signals.sendInfo") }}
      </button>
    </section>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Modal, SignalComposer } from "@/components";
import {
  useGrimoireStore,
  useLocaleStore,
  usePlayersStore,
  useSignalsStore,
} from "@/stores";

const grimoire = useGrimoireStore();
const playersStore = usePlayersStore();
const signalsStore = useSignalsStore();
const t = useLocaleStore().t;

const players = computed(() => playersStore.players.filter((p) => p.name && p.id));
</script>

<style scoped lang="scss">
.signal-target {
  display: block;
  margin-bottom: 1em;

  select {
    margin-left: 0.5em;
  }
}

.signal-section {
  margin-bottom: 1.5em;
}

.signal-send {
  margin-top: 0.75em;
  cursor: pointer;
}
</style>
